module.exports = __webpack_public_path__ + "img/icon_email.8aab4ece.svg";